import React from 'react';
import { Route, Routes } from 'react-router-dom';

import TrackerNew from '../../../containers/TrackerNew/TrackerNew';
import TrackerDetail from '../../../containers/TrackerNew/TrackerDetail/TrackerDetail';

const TAB_PATHS = {
  'sent-jobs': 'sent-jobs',
  'my-jobs': 'my-jobs',
};

const TrackerNewBase = () => (
  <Routes>
    <Route>
      {Object.keys(TAB_PATHS).map((path) => (
        <Route exact path={path} key={path} element={<TrackerNew tab={TAB_PATHS[path]} />} />
      ))}
      <Route exact path="details" element={<TrackerDetail />} />
      {/* Default to sent-jobs */}
      <Route path="/" element={<TrackerNew tab="sent-jobs" />} />
    </Route>
  </Routes>
);

export default TrackerNewBase;
